const moment = require('moment')

module.exports = (app) => {
  return {
    appInfo: Object.assign(app, {
      copyright: `© ${moment().format('YYYY')} ${app.name}. All rights reserved.`,
    }),
    appState: null,
    channel: 'default',
    userChannel: 'US',
    deviceId: null,
    routeState: {},
    loading: false,
    errors: [],
    location: null,
    menu: null,
    filteredMenu: [],
    searchedMenu: false,
    dietaryFilters: [],
    category: null,
    categoryBrands: null,
    ActiveSuperCategory: null,
    token: null,
    user: null,
    cart: null,
    rewards: [],
    showCart: false,
    isUpsellsView: false,
    isUpsellsModalView: false,
    showNav: false,
    showCart: false,
    activeAccountSection: null,
    orderHistory: null,
    howToRedeem: null,
    geolocation: null,
    showSitePopup: false,
    sitePopupInfo: null,
    globals: {},
    showWelcomePopup: true,
    showGroupOrderModal: false,
    showGroupOrderModalJoin: false,
    groupOrder: null,
    groupOrderOptions: null,
    startingGroupOrder: false,
    failed: {}
  }
}
